import styled, { keyframes } from "styled-components";

const rotating = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div`
  margin-top: 50px;

  img {
    width: 40px;
    height: 40px;
    animation: ${rotating} infinite 500ms linear;
  }
`;
